//import { lazyLoad } from './lazyload-init.js';

$(function() {

    /**
     * Navigataion
     */
    var $mainNavWrapper = $('.dev-landing #main-navigation');
    var $mainNav = $('.dev-landing #main-navbar');
    var $secondaryNav = $('.dev-landing #secondary-navbar');
    var $galleryContainer = $('#dev-landing-gallery-container');

    $mainNavWrapper.find('.nav-link').on('click', function(e){
        e.preventDefault();
        var menu_height = $mainNavWrapper.outerHeight();
        var parentNavbar = $(this).closest('.navbar').attr('id');

        // Close secondary menu(mobile) on click
        if(parentNavbar == 'secondary-navbar') {
            $secondaryNav.find('.toggle-close').trigger('click');
        }
        // Scroll to elem with offset on menu height
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top - menu_height
        }, 500);
    });
    

    // Gallery section
    if( $galleryContainer.length ) {
        var devLandingCarousel = $(".owl-dev-landing");

        devLandingCarousel.owlCarousel({
            //lazyload: true,
            items: 2,
            dots: false,
            nav: true,
            navText: [
            '<i class="fa fa-chevron-left" aria-hidden="true"></i>',
            '<i class="fa fa-chevron-right" aria-hidden="true"></i>'
            ],
            loop: false,
            responsive:{
                0:{
                    items:1
                },
                1200:{
                    items:2
                }
            }
        });
        
        /* Gallery Modal */
        // $('#developmentGallery').on('show.bs.modal', function (e) {
        //     lazyLoadInstance.update(); // Update LazyLoad
        // })
        // $('#developmentGallery').on('show.bs.modal', function (e) {
        //     var galleryItem = e.relatedTarget.dataset.itemId;
        //     // Go to clicked item
        //     bigimg.trigger('to.owl.carousel', [galleryItem, 400]);
        // })
    }

    // Enquire form
    var $formRYI = $('.dev-landing #enquire-now');

    if ( $formRYI.length ) {
        if ( $formRYI.hasClass('form--submitted') ) {
            let $target = $formRYI;
            let mainNavigationHeight = $('#main-navigation').outerHeight();
            let targetPos = $target.offset().top;
            let scrollOffset = targetPos - mainNavigationHeight;

            // Scroll to element
            $('html, body').animate({ scrollTop: scrollOffset });
        }
    }
    
});